<template>
  <v-footer class="footer" :style="marginBottom">
    <v-container class="mt-auto">
      <v-row v-if="hasBack">
        <v-col cols="12" class="text-left">
          <v-row class="mt-10" no-gutters>
            <v-card-text class="bordered-top bordered-bottom py-2 pl-4">
              <a @click.prevent="() => goBack()" href="#">
                <i class="mdi mdi-chevron-left"></i> {{ $t("return") }}
              </a>
            </v-card-text>
          </v-row>
        </v-col>
      </v-row>
      <v-row :class="!hasBack ? 'mt-4' : ''">
        <v-col cols="12" class="text-left">
          <p class="text-footer mb-0">{{ $t('copyright') }} {{ 'Version ' + appVersion }}</p>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>
<script setup lang="ts">
import { useRouter } from "vue-router";
const router = useRouter();
const hasBack = ref(true)
const route = useRoute();
const {
  public: { appVersion }
} = useRuntimeConfig();

watch(route, (to) => {
  hasBack.value = !to.path.includes('login') && !to.path.includes('prop-002') && to.path != '/'
}, { immediate: true });

const goBack = () => {
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push("/");
  }
};

const width = ref(window.innerWidth)
const height = ref(window.innerHeight)
const updateSize = () => {
  width.value = window.innerWidth
  height.value = window.innerHeight
}
onMounted(() => {
  window.addEventListener('resize', updateSize)
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', updateSize)
})
const marginBottom = computed(() => {
  return width.value < 1200 ? 'margin-bottom: 100px' : 'margin-bottom: 8px'
})

</script>
<style scoped>
.back-button .v-btn__content {
  color: #ffffff;
}
.footer {
  max-height: 150px;
  padding: 0 !important
}
.text-footer {
  font-size: 12.25px;
  max-height: 50px;
}
.v-container {
  padding: 0 !important;
  max-width: 100%
}
</style>